import gsap from "gsap"

export type SlideAlign = "left" | "right"

export const SLIDE_OFFSET = 80

export function getSectionAlign(sectionIndex: number): SlideAlign {
  return sectionIndex % 2 === 0 ? "left" : "right"
}

export function sectionHeaderClasses(align: SlideAlign, className = "") {
  const base = align === "right" ? "ml-auto text-right" : "text-left"
  return `${base} ${className}`.trim()
}

export function slideInFrom(
  element: Element | null | undefined,
  align: SlideAlign,
  options?: { duration?: number; start?: string; delay?: number },
) {
  if (!element) return

  gsap.from(element, {
    x: align === "right" ? SLIDE_OFFSET : -SLIDE_OFFSET,
    opacity: 0,
    duration: options?.duration ?? 1,
    delay: options?.delay ?? 0,
    ease: "power3.out",
    scrollTrigger: {
      trigger: element,
      start: options?.start ?? "top 85%",
      toggleActions: "play none none reverse",
    },
  })
}

export function slideAlternatingBlocks(
  container: Element | null | undefined,
  selector: string,
  startAlign: SlideAlign = "left",
  options?: { duration?: number; start?: string; delay?: number },
) {
  if (!container) return

  container.querySelectorAll(selector).forEach((block, index) => {
    const align: SlideAlign =
      index % 2 === 0 ? startAlign : startAlign === "left" ? "right" : "left"

    slideInFrom(block, align, options)
  })
}
